import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalUploadPage } from './modal-upload.page';

const routes: Routes = [
  {
    path: '',
    component: ModalUploadPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalUploadPageRoutingModule {}
